import React, { useState } from 'react';
import { ref, uploadBytes } from 'firebase/storage';
import { storage } from './firebase';

const CustomerDashboard = () => {
  const [isCompleted, setIsCompleted] = useState(false);

  const handleFileUpload = async (files) => {
    await Promise.all(
      files.map((file) => {
        const fileRef = ref(storage, file.name);
        return uploadBytes(fileRef, file);
      })
    );
    setIsCompleted(true);
  };

  return (
    <div className="fade-in">
      {!isCompleted ? (
        <div>
          <h2>Bitte Bild hochladen</h2>
          <input type="file" multiple onChange={(e) => handleFileUpload([...e.target.files])} />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default CustomerDashboard;